const carouselItems = [
  {
    title: '2024年度娱乐圈十大吃瓜事件盘点',
    desc: '回顾过去一年最令人震惊的娱乐圈八卦事件，从明星恋情曝光到综艺争议名场面，吃瓜群众在线一起回顾这些经典时刻。',
    image: 'https://readdy.ai/api/search-image?query=Year%20end%20entertainment%20news%20retrospective%20abstract%20collage%20with%20headline%20elements%20and%20trophy%20concept%2C%20warm%20coral%20and%20gold%20accents%2C%20editorial%20design%20layout%2C%20celebratory%20atmosphere%2C%20sophisticated%20visual%20style%2C%20soft%20glowing%20effects&width=1400&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    count: 'TOP 10',
  },
  {
    title: '综艺名场面合集：那些让全网沸腾的瞬间',
    desc: '精选近年热门综艺中最具话题性的名场面合集，从搞笑翻车到感人瞬间，每一个都值得吃瓜群众反复回味。',
    image: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20highlights%20abstract%20concept%20with%20dramatic%20stage%20moments%20and%20audience%20reaction%20visuals%2C%20warm%20amber%20stage%20lighting%2C%20entertainment%20atmosphere%2C%20editorial%20photography%2C%20dynamic%20composition&width=1400&height=600&seq=carousel-02&orientation=landscape',
    tag: '综艺回顾',
    count: '精选合集',
  },
  {
    title: '网红圈年度风云：大起大落的流量之争',
    desc: '从头部主播到新晋网红，盘点网红圈一年来最受关注的争议事件和流量变迁，揭秘背后的故事与真相。',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20and%20digital%20trends%20abstract%20visualization%20with%20rising%20graphs%20and%20profile%20elements%2C%20warm%20coral%20accents%20on%20dark%20background%2C%20modern%20digital%20culture%20concept%2C%20editorial%20design%2C%20dynamic%20flow&width=1400&height=600&seq=carousel-03&orientation=landscape',
    tag: '网红观察',
    count: '深度报告',
  },
  {
    title: '经典八卦事件深度复盘：时间线全梳理',
    desc: '对近年来最具影响力的八卦事件进行完整时间线复盘，从起因到高潮再到结局，吃瓜群众不可错过的真相还原。',
    image: 'https://readdy.ai/api/search-image?query=Timeline%20and%20investigation%20concept%20abstract%20visual%20with%20connected%20nodes%20and%20magnifying%20glass%20elements%2C%20warm%20amber%20and%20deep%20coral%20tones%2C%20journalism%20and%20research%20aesthetic%2C%20editorial%20layout%2C%20sophisticated%20design&width=1400&height=600&seq=carousel-04&orientation=landscape',
    tag: '深度复盘',
    count: '热门专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">焦点专题</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            精选专题回顾
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            不容错过的深度专题内容，吃瓜群众在线一站式回顾
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden bg-background-200 cursor-pointer h-[280px] md:h-[340px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/30 to-transparent"></div>

              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-full bg-primary-500/85 text-background-50 text-[10px] font-label whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="px-2.5 py-1 rounded-full bg-background-950/60 text-background-200 text-[10px] font-label whitespace-nowrap">
                  {item.count}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-2 group-hover:text-primary-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-background-300 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}